export enum ENUM_PAGE {
  LOGIN = "/login",
  REGISTER = "/register",
  HOME = "/",
  DASHBOARD = "/dashboard",
  TRANSACTION = "/transaction",
  MERCHANT = "/merchant",
  BANK = "/bank",
  CHANNEL = "/channel",
  TEST = "/test",
}
